<template>
  <div>
    <DocumentoModal ref="modalDocumento"/>
    <b-table
        :striped="true"
        :bordered="true"
        :hover="true"
        :responsive="true"
        table-variant="secondary"
        :fields="fields"
        :items="items"
        :busy="$store.getters['PTC_CadastroClienteClient/getIsLoadingTiposDocumento']"
        show-empty
        empty-text="Nenhum registro encontrado"
    >
      <!-- A virtual column -->
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(clientedocumentoseq)="data">
        <div class="text-nowrap">
          {{ data.item.clientedocumentoseq }}
        </div>
      </template>
      <template #cell(tipodocumentodescricao)="data">
        {{ data.item.tipodocumentodescricao}}
      </template>

      <template #cell(clientedocumentodatacadastro)="data">
        {{ data.item.clientedocumentodatacadastro }}
      </template>
      <template #cell(clientedocumentovalido)="data">
        {{ data.item.clientedocumentovalido }}
      </template>

      <template #cell(action)="data">
        <div
            class="d-flex"
            style="gap:5px"
        >
          <b-button
              variant="success"
              size="sm"
              @click="abrirModal('visualizar', data.item)"
              :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges']"
          >
            <feather-icon icon="SearchIcon"/>
            <span>Visualisar</span>
          </b-button>
          <b-button
              variant="warning"
              size="sm"
              @click="abrirModal('atualizar', data.item)"
              :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
          >
            <feather-icon icon="EditIcon"/>
            <span>editar</span>
          </b-button>
          <b-button
              variant="danger"
              size="sm"
              @click=""
              :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
          >
            <feather-icon icon="TrashIcon"/>
            <span>excluir</span>
          </b-button>
        </div>
      </template>

    </b-table>
    <b-row>
      <b-col>
        <b-button
            variant="gradient-primary"
            @click="abrirModal('inserir')"
            :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
        >
          <span class="align-middle">Adicionar Documento</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BFormSelect } from 'bootstrap-vue';

import DocumentoModal from '@/views/app/PTC/CadastroCliente/documento/documentoModal.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    DocumentoModal,
    BFormSelect,
  },
  data() {
    return {
      fields: [
        { key: 'clientedocumentoseq', label: 'Seq.' },
        { key: 'tipodocumentodescricao', label: 'Tipo de Documento' },
        { key: 'clientedocumentodatacadastro', label: 'Dt. Cadastro' },
        { key: 'clientedocumentovalido', label: 'Válido' },
        { key: 'action', label: 'Ações' },
      ],
      items: [],
    };
  },

  methods: {
    abrirModal(tipoOperacao, dados) {
      this.$refs.modalDocumento.abrirModal(tipoOperacao, dados);
    },
    async formatedFormDocumento() {
      this.items = [...this.getTiposDocumento];
    },
  },
  computed: {
    ...mapGetters({
      getTiposDocumento: 'PTC_CadastroClienteClient/getTiposDocumento',
    }),
  },
  created() {
    this.formatedFormDocumento();
  },
};
</script>
<style scoped lang="scss">

</style>
